<div class="container top-menu">
  <div class="header-top">
    <div class="top-user">
      <div class="exit-icon" [routerLink]="['/auth/logout']" title="{{ 'logout' | translate }}"></div>
      <div class="settings-icon" [routerLink]="['/profile']" routerLinkActive="settings-icon-active"></div>

      <!-- аватар -->
      <div *ngIf="Globals?.user?.avatar_image != 'loading' else ava_loading" class="avatars-default-min"
           [ngClass]="Globals?.avatars_default[AvatarService.user_avatar_num]?.tn"></div>

      <ng-template #ava_loading>
        <div class="avatars-default-min">
          <!-- loading -->
          <div class="lp-box">
            <div class="loading-pulse"></div>
          </div>
          <!-- /loading -->
        </div>
      </ng-template>

      <!-- /аватар -->

      <p>{{name}}</p>
      <p class="user-role">{{role}}</p>
    </div>

    <div *ngIf="Globals.show_proj_sel" class="projselect">
      <ng-select
        [items]="user_projects"
        class="select-project"
        bindLabel="name"
        bindValue="projects_id"
        [multiple]="false"
        [closeOnSelect]="true"
        [selectOnTab]="true"
        [(ngModel)]="Globals.select_project"
        (ngModelChange)="changeProjectSelect($event)"
        notFoundText="{{'no_name_projects' | translate}}"
        [hideSelected]="true"
        [clearable]="false"
        [searchable]="false"
        id="projects_select"
      >
      </ng-select>
    </div>

    <div class="header-logo">{{ 'smart_road' | translate }}</div>
  </div>

  <app-clock></app-clock>
  <ng-select
    [items]="Globals.langList"
    class="lang-select"
    bindLabel="name"
    bindValue="code"
    [multiple]="false"
    [closeOnSelect]="true"
    [selectOnTab]="true"
    [(ngModel)]="Globals.lang_select"
    (ngModelChange)="changeLangNew($event)"
    [clearable]="false"
    [searchable]="false"
    id="menu_select"
  >
    <ng-template ng-header-tmp>
      <div class="lang-sel-head">{{ 'inter_lang' | translate }}</div>
    </ng-template>
  </ng-select>

  <!-- новое меню -->
  <div
    class="admin-menu"
    *ngIf="Globals.user != undefined && top_menu_done"
    (click)="Globals.checkRoute()"
  >
    <p-menubar [model]="items"></p-menubar>
  </div>

</div>
